<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-lg-12">
          <validated-form-select name="type" :options="services" label="Tüüp" placeholder="- Vali teenus -"
                                 v-model="service.serviceId" validate="required" :validator="$validator"
                                 value-field="serviceId" text-field="serviceName"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <validated-form-input name="price" label="Ühiku hind" placeholder="Hind" v-model="service.price"
                                validate="required|decimal|min_value:0" :decimal="true" :validator="$validator"/>
        </div>
        <div class="col">
          <validated-form-input name="quantity" label="Kogus" placeholder="Kogus" v-model="service.quantity"
                                validate="required|decimal|min_value:0" :decimal="true" :validator="$validator"/>
        </div>
        <div class="col" v-if="!hideDiscount">
          <validated-form-input name="discount" label="Soodustuse %" placeholder="%" v-model.number="service.discount"
                                validate="decimal|max_value:100|min_value:0" :decimal="true" :validator="$validator"/>
        </div>
        <div class="col" v-if="!hideVat">
          <validated-form-input name="discount" label="KM %" placeholder="KM määr" v-model.number="service.vat"
                                validate="required|numeric|max_value:100|min_value:0" :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
import ValidatedFormInput from '@/components/ValidatedFormInput'
import ValidatedFormSelect from '@/components/ValidatedFormSelect'

export default {
  props: ['invoice', 'serviceChoices', 'hideVat', 'hideDiscount'],
  components: {ValidatedFormInput, ValidatedFormSelect},
  data() {
    return {
      service: {
        serviceId: null,
        quantity: null,
        price: null,
        discount: this.invoice.client.discount,
        mustBeGrouped: false,
        vat: null
      },
        services: []
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          this.$emit('done', this.service)
        })
      },
      selectVatRate(serviceVAT) {
        if (serviceVAT || serviceVAT === 0) return serviceVAT
        if (this.invoice.client.vatRate || this.invoice.client.vatRate === 0) return this.invoice.client.vatRate
        return 22
      }
    },
    watch: {
      'service.serviceId'(selectedServiceId) {
        let selectedService = this.services.find(s => s.serviceId === selectedServiceId)
        if (selectedService) {
          this.service.vat = this.selectVatRate(selectedService.vat)
          this.service.price = selectedService.clientPrice || selectedService.genericPrice
          this.service.type = selectedService.type
        }
        else {
          this.service.vat = null
          this.service.price = null
        }
      }
    },
    created() {
      this.services.splice(1, 0, ...this.serviceChoices)
    }
  }
</script>
